import type { ReactNode } from "react";

export interface SubSectionProps {
  className?: string;
  children?: ReactNode;
}

export const SubSection = (props: SubSectionProps) => {
  return (
    <section
      className={`subsection-shell w-full px-5 pt-24 md:px-8 md:pt-32 ${props.className || ""}`}
    >
      <div className="mx-auto max-w-6xl">{props.children}</div>
    </section>
  );
};
